const EMPTY_WEEK = {
  rows: [],
  weekTotal: 0,
  peakDay: "—",
  peakAmount: 0,
  avgDaily: 0,
};

export function buildWeeklyCollectionRows(weeklyData) {
  const list = weeklyData?.data;
  if (!Array.isArray(list) || !list.length) return { ...EMPTY_WEEK };

  const rows = list.map((el) => ({
    date: el.date,
    collection: Number(el.collection) || 0,
  }));
  const weekTotal = rows.reduce((s, r) => s + r.collection, 0);
  let peak = rows[0];
  rows.forEach((r) => {
    if (r.collection > peak.collection) peak = r;
    r.share =
      weekTotal > 0 ? Math.round((r.collection / weekTotal) * 1000) / 10 : 0;
  });

  return {
    rows,
    weekTotal,
    peakDay: peak?.date || "—",
    peakAmount: peak?.collection || 0,
    avgDaily: rows.length ? Math.round(weekTotal / rows.length) : 0,
  };
}
